import React, { useEffect, useState} from "react";
import { Layout, Space, Spin, Typography, Card, Button, List, Input, Row, Col, Select, message, Table, Popover, Drawer, Alert, Badge, Popconfirm} from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons"
import { utilities } from "../../utilities/utlities";
import api from "./api";
import { profileStatuses, roles } from "../../utilities/constants";
import { Link } from "react-router-dom";
import './styles.css'
import { useNavigator } from "../../utilities/navigation";
const CompanyUsers = (props) => {
    const [user] = useState(utilities.loggedUser)
    const {data, error, isError, isLoading } = api.useData(user.jwtToken)
    const [users, setUsers] = useState([])
    const [inputs, setInputs] = useState([{email: '',firstName: '',lastName: '',roles: [],status: '',emailInvalid: false,firstNameInvalid: false,lastNameInvalid: false,rolesInValid: false}])
    const [showAddForm, setShowAddForm] = useState(false)
    const [showDrawer, setShowDrawer] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [showPopConfirm, setShowpopconfirm] = useState(false)
    const [showPopover, setShowPopover] = useState(false)
    const addUserMutation = api.useNewUsers()
    const updateUserMutation = api.useUpdateUsers()

    const { Text } = Typography
    const { Content } = Layout
    const { Option } = Select
    const [navigator] = useNavigator()
    const columns = [{
        title: 'ID',
        dataIndex: 'id',
        render: (item) => {
            return item ? (
                <Text>{item.slice(item.length - 7,item.length)}</Text>
            ) : null
        }
    },{
        title: 'Name',
        dataIndex: 'firstName',
        render: (item,obj) => {
            return(
                <Text>{obj.firstName + " " + obj.lastName}</Text>
            )
        }
    },{
        title: 'Email',
        dataIndex: 'email',
        render: (item) => {
            return(
                <Text>{item}</Text>
            )
        }
    },{
        title: 'Role',
        dataIndex: 'roles',
        render: (item) => {
            let title = [...item]
            for(var i=0;i<title.length;i++){
                let role = roles.find(x=>x.value === title[i])
                if(role){
                    title[i] = role.name
                }
            }
            return(
                <Text>{title.join(',')}</Text>
            )
        }
    },{
        title: 'Created at',
        dataIndex: 'createdAt',
        render: (item) => {
            let date = new Date(item)
            return(
                <Text>{date.getDate()+"/"+(date.getMonth()+1)+"/"+date.getFullYear()}</Text>
            )
        }
    },{
        title: 'Profile Status',
        dataIndex: 'status',
        render: (item) => {
            return item ? (
                <Badge color={item === 'active' ? 'green' : 'orange'} text={profileStatuses.find(x=>x.value === item).name}/>
            ) : null
        }
    },{
        title: 'Actions',
            render: (item,obj) => {
                return(
                    <Popover visible = {showPopover} content={popoverContent} trigger="click" placement="bottom">
                        <Text onClick = {()=> {
                            setShowPopover(!showPopover)
                            if(showPopConfirm){
                                setShowpopconfirm(false)
                            }
                            setSelectedUser(obj)
                        }} style={{fontSize: 30,color: '#1890ff',cursor: 'pointer'}}>...</Text>
                    </Popover>
                )
            }
    }]
    const popoverContent = (
        <Space direction='vertical'>
            <Text onClick = {()=> {
                    setShowPopover(false)
                    setTimeout(() => {
                        setInputs([{...selectedUser}])
                        setShowDrawer(true)
                    }, 0);
                }} style={{color: 'rgba(0,0,0,0.85',marginBottom: 10,cursor: 'pointer'}}>
                Edit
            </Text>
            <Popconfirm
                visible = {showPopConfirm}
                onCancel = {()=> setShowpopconfirm(false)}
                onConfirm = {()=> updateUser(true)} 
                placement = 'leftTop' 
                okButtonProps = {{loading: updateUserMutation.isLoading}}
                title = {`Do you realy want to delete ${selectedUser && selectedUser.firstName}'s account ?`}>
                <Text onClick = {()=> setShowpopconfirm(true)} style={{color: 'rgba(0,0,0,0.85',marginBottom: 10,cursor: 'pointer'}}>
                    Delete
                </Text>
            </Popconfirm>
        </Space>
    );
    useEffect(()=>{
        if(user.type === 'admin'){
            navigator('/not-found')
            return
        }
        if(data){
            let companyUser = data.company.users.find(x=>x.id.toString() === user._id.toString())
            if(companyUser.roles.indexOf('owner') < 0){
                navigator('/not-found')
                return
            }
            setUsersData(data.company.users)
        }
    },[data])
    const setUsersData = (data) => {
        let users = [...data]
        users = users.filter(x=>x.id.toString() != user._id.toString())
        setUsers(users)
    }
    const updateInputValues = (index,e) => {
        const { name, value } = e.target;
        const list = [...inputs];
        list[index][name] = value;
        setInputs(list);
    }
    const updateSelectValues = (index,name,val) => {
        const list = [...inputs];
        list[index][name] = val;
        setInputs(list);
    }
    const handleAddInput = () => {
        setInputs([...inputs, {email: '',firstName: '',lastName: '',roles: [],status: '',emailInvalid: false,firstNameInvalid: false,lastNameInvalid: false,rolesInValid: false}]);
    }
    const handleRemoveInput = (index) => {
        const list = [...inputs];
        list.splice(index, 1);
        setInputs(list);
    }
    const onClickAddUser = () => {
        if(addUserMutation.isLoading){
            return
        }
        let newUsers = []
        for(var i=0;i<inputs.length;i++){
            let submit = true
            let user = {email: '',firstName: '',lastName: '',roles: [],status: 'active'}
            if(!utilities.validateEmail(inputs[i].email)){
                submit = false
                inputs[i].emailInvalid = true
            }else{
                inputs[i].emailInvalid = false
                user.email = inputs[i].email
            }
            if(inputs[i].firstName == ''){
                submit = false
                inputs[i].firstNameInvalid = true
            }else{
                inputs[i].firstNameInvalid = false
                user.firstName = inputs[i].firstName
            }
            if(inputs[i].lastName == ''){
                submit = false
                inputs[i].lastNameInvalid = true
            }else{
                inputs[i].lastNameInvalid = false
                user.lastName = inputs[i].lastName
            }
            if(inputs[i].roles.length == 0){
                submit = false
                inputs[i].rolesInValid = true
            }else{
                inputs[i].rolesInValid = false
                user.roles = inputs[i].roles
            }
            if(submit){
                newUsers.push(user)
            }
            setInputs([...inputs])
        }
        if(newUsers.length > 0){
            addUserMutation.reset()
            addUserMutation.mutate({users: newUsers,companyId: data.company._id,token: user.jwtToken},{
                onSuccess(data){
                    message.success('User(s) added successfully',2)
                    setInputs([{email: '',firstName: '',lastName: '',roles: [],status: '',emailInvalid: false,firstNameInvalid: false,lastNameInvalid: false,rolesInValid: false}])
                    let list = [...users]
                    list = list.concat(data.users)
                    setUsersData(list)
                    setShowDrawer(false)
                }
            })
        }
    }
    const editUser = (index,editing = true) => {
        let list = [...users]
        if(list[index].updating){
            return
        }
        list[index].editing = editing
        setUsers(list)
    }
    const updateUser = (remove = false) => {
        if(updateUserMutation.isLoading){
            return
        }
        let updatedUsers = []
        for(var i=0;i<inputs.length;i++){
            let user
            if(!remove){
                user = {
                    email: inputs[i].email,
                    firstName: inputs[i].firstName,
                    lastName: inputs[i].lastName,
                    roles: inputs[i].roles,
                    status: inputs[i].status
                }
            }else{
                user = {
                    email: selectedUser.email,
                    delete: true
                }
            }
            updatedUsers.push(user)
        }
        updateUserMutation.mutate({users: updatedUsers,companyId: data.company._id,token: user.jwtToken},{
            onSuccess(data){
                setUsersData(data.users)
                message.success('User updated',2)
                setShowDrawer(false)
                setShowpopconfirm(false)
            }
        })
    }
    const onCloseDrawer = () => {
        setShowDrawer(false)
    }
    return(
        <Layout className="layout">
            <Content style={{ padding: "0 100px",display: 'flex',justifyContent: 'flex-start' }} className = "site-layout-content">
                {/* {isLoading ? <Spin size = 'large'></Spin> : null} */}
                <div style = {{width: '100%'}}>
                    <div style = {{display: 'flex',justifyContent: 'space-between',marginBottom: 15}}>

                        <Text style={{fontSize: 16,fontWeight: 500,color: 'rgba(0,0,0,0.85)'}}>Manage Users</Text>
                        <Button onClick={()=> {
                            if(selectedUser){
                                setInputs([{email: '',firstName: '',lastName: '',roles: [],status: '',emailInvalid: false,firstNameInvalid: false,lastNameInvalid: false,rolesInValid: false}])
                            }
                            setSelectedUser(null)
                            setShowDrawer(true)
                        }} type='primary'>Add User</Button>
                    </div>
                    <Card className = {updateUserMutation.isLoading ? 'disabled' : ''}>
                        {/* <List
                            itemLayout="horizontal"
                            dataSource={users}
                            renderItem={(item,index) => 
                                !item.editing ? (<List.Item
                                    actions = {[
                                    <Button onClick={()=> editUser(index)} style = {{border: 'none',boxShadow: 'none'}} icon = {<EditFilled />} />]}
                                >
                                <List.Item.Meta
                                    title={item.firstName + " " + item.lastName}
                                />
                                {item.updating ? <Spin></Spin> : null}
                            </List.Item>) : (<List.Item
                                    actions = {[
                                    <Button onClick={()=> editUser(index,false)} style = {{border: 'none',boxShadow: 'none',color: 'lightgray'}} icon = {<CloseCircleFilled />} />,
                                    <Button onClick={()=> updateUser(index)} style = {{border: 'none',boxShadow: 'none',color: '#1890ff'}} icon = {<CheckCircleFilled />} />
                                ]}
                                >
                                    <Space direction='vertical'>
                                        <Text style = {{fontWeight: '500'}}>First Name</Text>
                                        <Input id={"editindexfirst"+index} defaultValue = {item.firstName}/>
                                    </Space>
                                    <Space direction='vertical'>
                                        <Text style = {{fontWeight: '500'}}>Last Name</Text>
                                        <Input id={"editindexlast"+index} defaultValue = {item.lastName}/>
                                    </Space>
                                    <Space direction='vertical'>
                                        <Text style = {{fontWeight: '500'}}>Roles</Text>
                                        <Select
                                            style = {{width: '6vw'}}
                                            name = "roles"
                                            id={"editindexroles"+index}
                                            defaultValue = {item.roles}
                                            value = {item.roles}
                                            onChange = {(e)=> {
                                                const list = [...users];
                                                list[index].roles = e;
                                                setInputs(list);
                                            }}
                                            mode = 'multiple'>
                                                {roles.map((val)=>{
                                                    return(
                                                        <Option value={val.value}>{val.name}</Option>
                                                    )
                                                })}
                                        </Select> 
                                    </Space>
                            </List.Item>)}
                        /> */}
                        <Table loading = {isLoading} dataSource = {users} columns = {columns} rowKey="id"/>
                    </Card>
                </div>
                {/* <div style = {{width: '50%',marginTop: 15}} className={showAddForm ? "add-form show" : "add-form"}>
                <div style = {{display: 'flex',justifyContent: 'center',marginBottom: 10}}>
                    <Text style={{fontSize: 16,fontWeight: 500,color: 'rgba(0,0,0,0.85)'}}>Add New User(s)</Text>
                </div>
                <Card className = {addUserMutation.isLoading ? 'disabled' : ''}>
                    <Space direction='vertical' style = {{width: '100%'}}>
                        {inputs.map((item,index)=>{
                            return(
                                <Input.Group key = {index}>
                                    <Row gutter={8}>
                                        <Col span={5}>
                                            <Input
                                                className = {item.emailInvalid ? 'invalid' : ''}
                                                name = "email"
                                                id = {"email"+index}
                                                value = {item.email}
                                                onChange={(e)=> updateInputValues(index,e)}
                                                placeholder="awais.khan@gmail.com"/> 
                                        </Col>
                                        <Col span={5}>
                                            <Input
                                                className = {item.firstNameInvalid ? 'invalid' : ''}
                                                name = "firstName"
                                                id = {"firstName"+index}
                                                value = {item.firstName}
                                                onChange={(e)=> updateInputValues(index,e)}
                                                placeholder="Awais"/> 
                                        </Col>
                                        <Col span={5}>
                                            <Input
                                                className = {item.lastNameInvalid ? 'invalid' : ''}
                                                name = "lastName"
                                                id = {"lastName"+index}
                                                value = {item.lastName}
                                                onChange={(e)=> updateInputValues(index,e)}
                                                placeholder="Khan"/> 
                                        </Col>
                                        <Col span = {7}>
                                            <Select
                                                style = {{width: '100%',borderColor: 'red'}}
                                                className = {item.rolesInValid ? 'invalid-select' : ''}
                                                name = "roles"
                                                id = {"roles"+index}
                                                value = {item.roles}
                                                mode = 'multiple'
                                                onChange={(e)=> updateSelectValues(index,'roles',e)}
                                                placeholder="Moderator, Editor">
                                                    {roles.map((val)=>{
                                                        return(
                                                            <Option value={val.value}>{val.name}</Option>
                                                        )
                                                    })}
                                            </Select> 
                                        </Col>
                                        <Col span={2} style = {{position: 'absolute',right: 10}}>
                                            <Button
                                                onClick = {()=> handleRemoveInput(index)} 
                                                icon={<DeleteOutlined />}></Button>
                                        </Col>
                                    </Row>
                                </Input.Group>
                            )
                        })}
                        <Button onClick = {() => handleAddInput()} icon = {<PlusOutlined />} type = 'default'></Button>
                    </Space>
                    <div style = {{display: 'flex',justifyContent: 'flex-end',width: '100%'}}>
                        <Button loading = {addUserMutation.isLoading} onClick={onClickAddUser} type='primary'>Add</Button>
                    </div>
                    {addUserMutation.data && addUserMutation.data.invalidEmails ?
                    <Text type='danger'>Following email(s) <Text type='danger' style = {{fontWeight: 'bold'}}>{addUserMutation.data.invalidEmails}</Text> are already taken</Text> : null}
                </Card>
                </div> */}
            </Content>
            <Drawer 
                size='large' 
                title="Add Users" 
                placement='right' 
                visible={showDrawer} 
                onClose={onCloseDrawer}
                extra={
                    <Space>
                      <Button onClick = {onCloseDrawer}>Cancel</Button>
                      <Button className = {addUserMutation.isLoading || updateUserMutation.isLoading ? 'disabled' : ''} onClick = {()=>{
                          if(selectedUser){
                            updateUser()
                          }else{
                            onClickAddUser()
                          }
                      }} loading = {addUserMutation.isLoading || updateUserMutation.isLoading} type="primary">
                        Save
                      </Button>
                    </Space>
                }>
                <Alert closable message="Login credentials will be sent to the user right after you save" type="info" showIcon />
                {inputs.map((item,index)=>{
                    return(
                        <Space className={addUserMutation.isLoading || updateUserMutation.isLoading ? 'disabled' : ''} size={20} style = {{width: '100%',marginTop: 20}} direction='vertical'>
                            <div className='input'>
                                <Text type='secondary' style = {{width: '25%'}}>First Name:</Text>
                                <Input
                                    style = {{width: '75%'}}
                                    className = {item.firstNameInvalid ? 'invalid' : ''}
                                    name = "firstName"
                                    id = {"firstName"+index}
                                    value = {item.firstName}
                                    onChange={(e)=> updateInputValues(index,e)}
                                    placeholder="Awais"/> 
                            </div>
                            <div className='input'>
                                <Text type='secondary' style = {{width: '25%'}}>Last Name:</Text>
                                <Input
                                    style = {{width: '75%'}}
                                    className = {item.lastNameInvalid ? 'invalid' : ''}
                                    name = "lastName"
                                    id = {"lastName"+index}
                                    value = {item.lastName}
                                    onChange={(e)=> updateInputValues(index,e)}
                                    placeholder="Khan"/> 
                            </div>
                            {!selectedUser ? 
                            <div className='input'>
                                <Text type='secondary' style = {{width: '25%'}}>Email:</Text>
                                <Input
                                    style = {{width: '75%'}}
                                    className = {item.emailInvalid ? 'invalid' : ''}
                                    name = "email"
                                    id = {"email"+index}
                                    value = {item.email}
                                    onChange={(e)=> updateInputValues(index,e)}
                                    placeholder="awais@mwan.com"/> 
                            </div> : null}
                            <div className='input'>
                                <Text type='secondary' style = {{width: '25%'}}>Roles:</Text>
                                <Select
                                    style = {{width: '75%'}}
                                    className = {item.rolesInValid ? 'invalid-select' : ''}
                                    name = "roles"
                                    id = {"roles"+index}
                                    value = {item.roles}
                                    mode = 'multiple'
                                    onChange={(e)=> updateSelectValues(index,'roles',e)}
                                    placeholder="Moderator, Editor">
                                        {roles.map((val)=>{
                                            return(
                                                <Option value={val.value}>{val.name}</Option>
                                            )
                                        })}
                                </Select> 
                            </div>
                            {selectedUser ? 
                            <div className='input'>
                                <Text type='secondary' style = {{width: '25%'}}>Status:</Text>
                                <Select
                                    style = {{width: '75%'}}
                                    className = {item.rolesInValid ? 'invalid-select' : ''}
                                    name = "status"
                                    id = {"status"+index}
                                    value = {item.status}
                                    defaultValue = 'active'
                                    onChange={(e)=> updateSelectValues(index,'status',e)}>
                                        {profileStatuses.map((val)=>{
                                            return(
                                                <Option value={val.value}>{val.name}</Option>
                                            )
                                        })}
                                </Select> 
                            </div> : null}
                            {addUserMutation.data && addUserMutation.data.invalidEmails ?
                            <Text type='danger'>Following email(s) <Text type='danger' style = {{fontWeight: 'bold'}}>{addUserMutation.data.invalidEmails}</Text> are already taken</Text> : null}
                        </Space>
                    )
                })}
            </Drawer>
        </Layout>
    )
}
export default CompanyUsers